import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin-left: 363px;
  margin-top: -30px;
  margin-bottom: 10px;
`;
